import { useMemo } from 'react';

import type { GenerateSearchUrlType } from '../../common/ui/app-context';
import { defaultGenerateSearchUrl } from '../../common/utils/default-generate-search-url';
import { isRovoJourneyIdEnabled } from '../../common/utils/quick-find/rovo-journey-id';
import { usePrimaryProduct } from '../../controllers/store/bootstrap';
import { useRovoJourneyId } from '../../controllers/store/quick-find';

/**
 * Adds the Quick Find journey to Full Page Search destination URLs without updating the current
 * page URL or the journey observed by an already-open Search/SAIN surface.
 */
export const useGenerateSearchUrlWithRovoJourneyId = (
	generateSearchUrl: GenerateSearchUrlType | undefined,
): GenerateSearchUrlType | undefined => {
	const [primaryProduct] = usePrimaryProduct();
	const rovoJourneyId = useRovoJourneyId();
	const shouldIncludeRovoJourneyId = isRovoJourneyIdEnabled(primaryProduct);

	return useMemo(() => {
		if (!shouldIncludeRovoJourneyId) {
			return generateSearchUrl;
		}

		return (urlQueryParams, ...rest) =>
			(generateSearchUrl ?? defaultGenerateSearchUrl)(
				{ ...urlQueryParams, rovoJourneyId },
				...rest,
			);
	}, [generateSearchUrl, rovoJourneyId, shouldIncludeRovoJourneyId]);
};
